import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import InputFloating from '../../../../commons/InputFloating';
import ExpDropSelector from '../../../../commons/ExpDropSelector';
import MobLoader from '../../../../commons/MobLoader';
import ErrorBox from '../../../../commons/ErrorBox';
import ImageUploader from '../../../../commons/ImageUploader';
import warn from './../../../../assets/img/warning.png';
import outerBoxImage from './../../../../assets/img/outer-box.png';
import innerBoxImage from './../../../../assets/img/inner-box.png';
import looseUnitsImg from './../../../../assets/img/loose-units.png';
import InwardingApiHandler from '../../InwardingApiHandler';
import ImageViewer2 from '../../../../commons/ImageViewer2';
import close from './../../../../assets/img/close.png';
import filled_tick from './../../../../assets/img/filled_tick.png';
import { sendEventToHevo } from '../../../../utilities/manageEvents.js';

export default class FreebieDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialLoading: true,
            loading: false,
            freebieType: null,
            freebieDetails: null,
            vendorInvoiceLineItemNumber: '0',
            dateType: null,
            showAddDamagedQty: false,
            innerBoxQty: '',
            outerBoxQty: '',
            looseUnits: '',
            outerBoxQtyDamaged: '',
            innerBoxQtyDamaged: '',
            looseUnitsDamaged: '',
            caseSizeImageUrl: '',
            expTimeSpanList: ['Days', 'Months', 'Years'],
            expDays: 0,
            expTimeSpan: 'Days',
            damageReasonType: null,
            innerBoxes: 0,
            l1CaseSize: 0,
            l2CaseSize: 0,
            editCaseSizeMode: false,
            manufacturingDate: '',
            expiryDate: '',
            initialL1CaseSize: '',
            initialL2CaseSize: '',
            initialInnerBoxes: '',
            vinv: props.location.state.vinv,
            palletId: props.location.state.palletId,
            parentListingId: props.location.state.parentListingId,
            parentListingTitle: props.location.state.parentListingTitle,
            freebieJpin: props.location.state.freebieJpin,
            shortInward: false,
            shortInwardReason: '',
            showAddedToPalletBox: false,
            errorType: ''
        }
    }

    sendEvent = (eventName, eventData) => {
        const { vinv, palletId, parentListingId } = this.state;
        if (!eventName || !eventData) {
            console.error('some parameter not passed in event');
            return;
        }
        let req = { ...eventData };

        req["inwarding_session_id"] = vinv;
        req["gric"] = palletId;
        req["parent_listing_id"] = parentListingId;
        sendEventToHevo(eventName, req);
    }

    componentDidMount = () => {
        const freebieData = this.props.location.state;

        let l1 = 0, l2 = 0, innerBoxes = 0;
        this.setState({ freebieType: freebieData.freebieType, freebieDetails: freebieData.data, initialLoading: false, l1CaseSize: l1, l2CaseSize: l2, innerBoxes: innerBoxes, initialL1CaseSize: l1, initialL2CaseSize: l2, initialInnerBoxes: innerBoxes });
    }

    getHeader = () => {
        return (
            <div className="header-name-bar" style={{ left: '0' }}>
                <div className="row">
                    <div className="col-xs-1">
                        <div className="visible-xs visible-sm" style={{ lineHeight: '65px', fontSize: '25px' }} onClick={() => { this.props.history.goBack(); }}><i className="fas fa-arrow-left"></i></div>
                    </div>
                    <div className="col-xs-11">
                        <div className="header-page-name">Freebie Product Details</div>
                    </div>
                </div>
            </div>
        )
    }

    imageMrpUI = () => {
        // display product's image, title, mrp, offer
        const { freebieDetails } = this.state;
        return (
            <React.Fragment>
                <div style={{ display: 'flex' }}>
                    <div style={{ textAlign: 'center', marginRight: '10px', width: '30%' }}>
                        <img src={freebieDetails.capturedFrontSideImageUrl} style={{ maxWidth: '100%', maxHeight: '100px' }} alt="product" />
                    </div>
                    <div style={{ width: '70%' }}>
                        <div className="v-imp-txt top-ten">{freebieDetails.productTitle}</div>
                        <div className="top-ten" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="pr-mrp" style={{ border: '1px solid', width: 'fit-content', padding: '5px' }}>MRP ₹{freebieDetails.mrp}</div>
                            <div className="greenBac" style={{ textAlign: 'center', width: '70px' }}>Freebie</div>
                        </div>
                    </div>
                </div>
                <div style={{ backgroundColor: '#F7F4CB', padding: '10px', color: '#BD2E23', marginTop: '8px' }}>Note: Inward all parent product's quantities as per invoice before inwarding freebie</div>
                <div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '5px' }}></div>
            </React.Fragment>
        )
    }

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;
        const tar = ["outerBoxQty", "innerBoxQty", "looseUnits", "outerBoxQtyDamaged", "innerBoxQtyDamaged", "looseUnitsDamaged", "l1CaseSize", "innerBoxes"];
        if (tar.includes(name) && Number(val) < 0) {
            val = 0;
        }

        this.setState({
            [name]: val
        })

        // logic to set l2 case size
        let l2 = 0;
        const { l1CaseSize, innerBoxes } = this.state;
        if (name === "l1CaseSize") {
            if (innerBoxes <= 0) {
                l2 = 0;
            }
            else {
                l2 = innerBoxes * val;
            }
            this.setState({ l2CaseSize: l2 });
        }
        else if (name === "innerBoxes") {
            l2 = val * l1CaseSize;
            if (Number(val) === 0) {
                this.setState({ l2CaseSize: l2, innerBoxQty: '', innerBoxQtyDamaged: '' });
            }
            else {
                this.setState({ l2CaseSize: l2 });
            }
        }
    }

    isManufacturingDateValid = () => {
        const { manufacturingDate } = this.state;
        if (manufacturingDate) {
            let today = new Date().getTime();
            let mDate = new Date(manufacturingDate).getTime();
            if (today < mDate) {
                return false;
            }
        }
        return true;
    }

    isExpiryDateValid = () => {
        const { expiryDate } = this.state;
        if (expiryDate) {
            let today = new Date().getTime();
            let expDate = new Date(expiryDate).getTime();
            if (today > expDate) {
                return false;
            }
        }
        return true;
    }

    makeDatesNull = () => {
        this.setState({ manufacturingDate: '', expiryDate: '' });
    }

    dateFormatChange = (str) => {
        return str.substring(8, 10) + '/' + str.substring(5, 7) + '/' + str.substring(0, 4);
    }

    resetDamagedParameters = () => {
        const { showAddDamagedQty } = this.state;
        this.setState({
            showAddDamagedQty: !showAddDamagedQty,
            damageReasonType: null,
            outerBoxQtyDamaged: '',
            innerBoxQtyDamaged: '',
            looseUnitsDamaged: ''
        })
    }

    closeAddedToPalletBox = () => {
        this.setState({ showAddedToPalletBox: false });
        this.props.history.push({
            pathname: '/Inwarding/AddPallet/' + this.state.vinv
        })
    }

    // // for now this is not used as we are not getting existing l1 and l2 case size for the product in any case
    // getInitialInnerBoxes = (l1, l2) => {
    //     let innerBoxes = -1;
    //     if (l1 >= 0 && l2 === 0) {
    //         innerBoxes = 0;
    //     }
    //     else if (l1 > 0 && l2 > 0) {
    //         innerBoxes = l2 / l1;
    //     }

    //     return innerBoxes;
    // }

    resetCaseSize = () => {
        const { initialL1CaseSize, initialL2CaseSize, initialInnerBoxes } = this.state;
        this.setState({ l1CaseSize: initialL1CaseSize, l2CaseSize: initialL2CaseSize, innerBoxes: initialInnerBoxes, editCaseSizeMode: false, caseSizeImageUrl: '' });
    }

    isItemAbleToAddInPallet = () => {
        const { manufacturingDate, expiryDate, caseSizeImageUrl, initialL1CaseSize, initialL2CaseSize, outerBoxQty, innerBoxQty, looseUnits, l1CaseSize, l2CaseSize, outerBoxQtyDamaged, innerBoxQtyDamaged, looseUnitsDamaged } = this.state;

        // check if image is uploaded if case size is changes
        let imageAddedAfterCaseSizeChange = true;
        if (((initialL1CaseSize !== Number(l1CaseSize)) || (initialL2CaseSize !== Number(l2CaseSize))) &&
            (!caseSizeImageUrl)
        ) {
            imageAddedAfterCaseSizeChange = false;
        }

        if ((outerBoxQty || innerBoxQty || looseUnits || outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) &&
            manufacturingDate && expiryDate &&
            this.isManufacturingDateValid() && this.isExpiryDateValid() &&
            Number(l1CaseSize) !== Number(l2CaseSize) &&
            // (!showAddDamagedQty || damageReasonType) &&
            imageAddedAfterCaseSizeChange
        ) {
            return true;
        }

        return false;
    }

    addItemToPallet = (shortInward) => {
        const { freebieType, freebieDetails, vinv, palletId, parentListingId, parentListingTitle, manufacturingDate, expiryDate, freebieJpin, outerBoxQty, innerBoxQty, looseUnits, outerBoxQtyDamaged, innerBoxQtyDamaged, looseUnitsDamaged, l1CaseSize, l2CaseSize, innerBoxes, caseSizeImageUrl } = this.state;
        let req = {};

        if (freebieType === 'existing') {
            req.listingId = freebieDetails.listingId;
            req.jpin = freebieJpin;
            req.listingIdentificationType = 'LISTING_MISMATCHED_EXISTING'
        }
        else if (freebieType === 'new') {
            req = { ...freebieDetails };
            req.isNewProduct = true;
            req.listingId = null;
            req.jpin = null;
            req.listingIdentificationType = null;
        }

        req.vendorInvoiceId = vinv;
        req.goodsReceivingContainerId = palletId;

        req.parentListingId = parentListingId;
        req.labelCodeMatchStatus = "NOT_IN_PO";
        req.vendorInvoiceLineItemNumber = '0';
        req.isFreebie = true;
        req.goodsReceivedItemInwardReasonCode = shortInward ? 'VENDOR_SUPPLIED_LESS_QUANTITY' : null;
        req.caseSizeImageUrl = caseSizeImageUrl ? caseSizeImageUrl : null;
        req.isPresentInPO = false;

        if (!manufacturingDate) {
            req.manufacturingDate = new Date().getTime();
        } else {
            req.manufacturingDate = new Date(manufacturingDate).getTime();
        }

        req.expiryDate = new Date(expiryDate).getTime();
        req.l1CaseSize = '' + l1CaseSize;
        req.l2CaseSize = '' + l2CaseSize;

        let goodQty = 0, badQty = 0;
        let total = (innerBoxes <= 0) ? l1CaseSize : l1CaseSize * innerBoxes;

        if (outerBoxQty || innerBoxQty || looseUnits) {
            goodQty = (total * outerBoxQty) + (l1CaseSize * innerBoxQty) + (1 * looseUnits);
        }

        if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            badQty = (total * outerBoxQtyDamaged) + (l1CaseSize * innerBoxQtyDamaged) + (1 * looseUnitsDamaged);
        }

        req.nonDamagedQty = goodQty;
        req.damagedQty = badQty;
        req.qty = goodQty + badQty;

        this.sendEvent('ON_CLICK_TAG_TO_PALLET_FREEBIE', {
            inner_box_qty_before: this.state.initialInnerBoxes,
            inner_box_qty_after: this.state.innerBoxes,
            loose_qty_before: this.state.initialL1CaseSize,
            loose_qty_after: this.state.l1CaseSize,
            image_url: req.caseSizeImageUrl,

            manufacturing_date: req.manufacturingDate,
            expiry_date: req.expiryDate,

            good_qty: goodQty,
            damaged_qty: badQty,
            mrp: freebieDetails.mrp,

            parent_listing_id: parentListingId ? parentListingId : null,
            parent_listing_title: parentListingTitle ? parentListingTitle : null,

            is_new_freebie: req.isNewProduct ? true : false,
            listing_id: req.listingId ? req.listingId : null,
            jpin: req.jpin ? req.jpin : null
        });

        this.setState({ loading: true });
        InwardingApiHandler.addToPallet(req)
            .then(resp => {
                if (resp.decreasedParentQty > 0) {
                    //if parent is short inwarded, show this (only after parent is fully inwarded we can inward its freebie)
                    this.setState({ errorType: 'special', error: `Please return the ${resp.decreasedParentQty} no. of Parent Product ${parentListingTitle} as the no. of Freebie products sent by the vendor is less than expected quantity` });
                }
                else if (resp.freebieShortInwardQty > 0) {
                    //if parent is fully inwarded but freebie is short inwarded
                    this.setState({ shortInward: true });
                }
                else {
                    this.setState({ showAddedToPalletBox: true });
                }

            }).catch(error => {
                this.setState({ error: error.error.error });
            })
            .finally(() => {
                this.setState({ loading: false });
            })
    }

    changeExpiryDate = () => {
        const { expTimeSpan, expDays, manufacturingDate } = this.state;
        if (manufacturingDate) {
            let mDate = new Date(manufacturingDate);
            let days = parseInt(expDays, 10);
            switch (expTimeSpan) {
                case 'Years':
                    mDate.setYear(mDate.getYear() + parseInt(days, 10) + 1900);
                    break;
                case 'Months':
                    mDate.setMonth(mDate.getMonth() + parseInt(days, 10));
                    break;
                default:
                    mDate.setDate(mDate.getDate() + parseInt(days, 10));
            }
            mDate = JSON.stringify(mDate)
            let exp = mDate.slice(1, 11)
            this.setState({ expiryDate: exp });
        }
    }

    handleExpTimeChange = (e) => {
        this.setState({ expDays: e.target.value }, function () {
            this.changeExpiryDate();
        });
    }

    handelExpTimeSpanChange = (val) => {
        this.setState({ expTimeSpan: val }, function () {
            this.changeExpiryDate();
        });
    }

    getShelfLife = (dateType) => {
        let mfg = this.state.manufacturingDate;
        let exp = this.state.expiryDate;
        if (dateType === 1 || dateType === 2) {
            if (mfg && exp && this.isManufacturingDateValid() && this.isExpiryDateValid()) {
                let m = new Date(mfg).getTime();
                let e = new Date(exp).getTime();
                let t = new Date().getTime();
                let s = ((e - t) / (e - m) * 100).toFixed(1); //shelf_life_left
                return (
                    <div style={{ border: '1px solid black', margin: '8px 30px', padding: '6px', textAlign: 'center', borderRadius: '5px', backgroundColor: s > 70 ? '#e4ffdd' : '#ffffcc' }}>
                        Note: Remaining shelf life is {s}%
                    </div>
                )
            }
            else {
                return null;
            }
        }
        else if (dateType === 3) {
            if (exp && this.isExpiryDateValid()) {
                let e = new Date(exp).getTime();
                let t = new Date().getTime();
                let s = ((e - t) / 86400000).toFixed(0);
                return (
                    <div style={{ border: '1px solid black', margin: '8px 30px', padding: '6px', textAlign: 'center', borderRadius: '5px', backgroundColor: s > 100 ? '#e4ffdd' : '#ffffcc' }}>
                        Note: The product will expire in {s} days
                    </div>
                )
            }
            else {
                return null;
            }
        }
    }

    setMfgDateToday = () => {
        let d = new Date().getTime();;
        this.setState({ manufacturingDate: d });
    }

    freebieDetailsUI = () => {
        const { manufacturingDate, expiryDate, expDays, expTimeSpan, expTimeSpanList, dateType, looseUnits, showAddDamagedQty, outerBoxQtyDamaged, innerBoxQtyDamaged, looseUnitsDamaged, outerBoxQty, innerBoxQty, receivedQuantity, l1CaseSize, l2CaseSize, innerBoxes, editCaseSizeMode, caseSizeImageUrl, initialL1CaseSize, initialL2CaseSize } = this.state;
        let goodQty = 0, badQty = 0;
        let total = (innerBoxes <= 0) ? l1CaseSize : l1CaseSize * innerBoxes;

        if (outerBoxQty || innerBoxQty || looseUnits) {
            goodQty = (total * outerBoxQty) + (l1CaseSize * innerBoxQty) + (1 * looseUnits);
        }

        if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            badQty = (total * outerBoxQtyDamaged) + (l1CaseSize * innerBoxQtyDamaged) + (1 * looseUnitsDamaged);
        }

        return (
            <div style={{ maxWidth: '700px', width: '100%' }}>
                <div className={this.isItemAbleToAddInPallet() ? "lw-btn dtl-box" : "dtl-box"} style={{ padding: '10px 15px', scrollBehavior: 'smooth' }}>
                    <div>
                        {this.imageMrpUI()}

                        {/* <div className="top-twenty">
                            <InputFloating type="number" label="Vendor Invoice Line Item Number" name="vendorInvoiceLineItemNumber" value={vendorInvoiceLineItemNumber} onChange={this.setNameToValue} />
                            {(!this.isVendorInvoiceLineItemNumberValid()) ? <div className="error-text-fix">Please Enter Valid Line Item Number</div> : null}
                        </div> */}

                        <div className="top-twenty" style={{ maxWidth: '500px' }}>
                            <div className="v-imp-txt" style={{ marginBottom: '14px', fontWeight: '700' }}>Case Size Details</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="centralized">
                                    <div>
                                        <span>1</span><img src={outerBoxImage} className="small-image" alt='L1' />
                                    </div>
                                    <div>Outer Box</div>
                                </div>
                                <div>has</div>
                                {(innerBoxes !== -1) ?
                                    <React.Fragment>
                                        <div className="centralized">
                                            <div>
                                                <input type='number' className='small-input2' name="innerBoxes" value={innerBoxes} onChange={(e) => { this.setNameToValue(e) }} disabled={!editCaseSizeMode} /><img src={innerBoxImage} className="small-image" alt='L2' />
                                            </div>
                                            <div>Inner Box</div>
                                        </div>
                                        <div>with</div>
                                    </React.Fragment>
                                    :
                                    null
                                }
                                <div className="centralized">
                                    <div>
                                        <input type='number' id="looseUnits" className='small-input2' name="l1CaseSize" value={l1CaseSize} onChange={(e) => { this.setNameToValue(e) }} disabled={!editCaseSizeMode} /><img src={looseUnitsImg} className="small-image" alt='loose units' />
                                    </div>
                                    <div>Units</div>
                                </div>
                                <div>=</div>
                                <div className="centralized">
                                    <div>{total}</div>
                                    <div>Total Units</div>
                                </div>
                            </div>
                        </div>

                        {((initialL1CaseSize !== Number(l1CaseSize)) || (initialL2CaseSize !== Number(l2CaseSize))) ?
                            <div>
                                <div style={{ margin: '10px 0px', color: '#ee8f29', fontWeight: '500' }}>You have edited the case sizes, Please add a photo proof of new case:</div>
                                <div style={{ textAlign: 'center' }}>
                                    <div className="image-up-not">Upload Case Size Image</div>
                                    {(caseSizeImageUrl) ?
                                        <div style={{ margin: '10px' }}>
                                            <ImageViewer2 src={caseSizeImageUrl} shouldRemove={true} onRemove={() => { this.setState({ caseSizeImageUrl: '' }) }} alt='Img' />
                                        </div>
                                        :
                                        <div><ImageUploader url="inwarding/upload" type="caseSizeImageUrl" handleUploadResponse={(resp, type) => { this.setState({ caseSizeImageUrl: resp }) }} captureOnly={true} /></div>
                                    }
                                </div>
                            </div>
                            :
                            <div style={{ marginTop: '10px', fontWeight: '600' }}><span style={{ textDecoration: 'underline' }}>Note:</span> Case Sizes as per system data</div>
                        }

                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
                            {(editCaseSizeMode) ?
                                <button className="btn btn-secondary" style={{ border: '1px solid' }} onClick={this.resetCaseSize}>Reset Case Size</button> :
                                <button className="btn btn-info" onClick={() => { this.setState({ editCaseSizeMode: true }, () => { document.getElementById('looseUnits').focus(); }) }}>Edit Case Size</button>
                            }
                        </div>

                        <div style={{ maxWidth: '600px' }}>
                            <div className="v-imp-txt top-twenty" style={{ fontWeight: '500', textAlign: 'center', color: 'green', border: '1px solid #BFBFBF', borderBottom: 'none', padding: '7px' }}>{receivedQuantity} Units already received</div>
                            <div className="v-imp-txt" style={{ fontWeight: '700', textAlign: 'center', border: '1px solid #BFBFBF', borderBottom: 'none', padding: '7px' }}>Good Quantity Received</div>
                            <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF', borderBottom: 'none', }} >
                                <div className='centralized2'>Outer Box</div>
                                <div className='centralized2'>Inner Box</div>
                                <div className='centralized2'>Loose Units</div>
                                <div className='centralized2'>Total Units</div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF' }} >
                                <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                    <input type='number' className='small-input-cs' name="outerBoxQty" value={outerBoxQty} onChange={(e) => { this.setNameToValue(e) }} />
                                </div>
                                <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                    {(Number(innerBoxes) > 0) ?
                                        <input type='number' className='small-input-cs' name="innerBoxQty" value={innerBoxQty} onChange={(e) => { this.setNameToValue(e) }} />
                                        :
                                        <div>-</div>
                                    }
                                </div>
                                <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                    <input type='number' className='small-input-cs' name="looseUnits" value={looseUnits} onChange={(e) => { this.setNameToValue(e) }} />
                                </div>
                                <div className='centralized2' >
                                    {goodQty}
                                </div>
                            </div>
                        </div>


                        {(showAddDamagedQty) ?
                            <div style={{ maxWidth: '600px' }}>
                                <div className="v-imp-txt" style={{ fontWeight: '700', textAlign: 'center', border: '1px solid #BFBFBF', borderTop: 'none', borderBottom: 'none', padding: '7px' }}>Damaged Quantity received</div>
                                <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF', borderBottom: 'none', }} >
                                    <div className='centralized2'>Outer Box</div>
                                    <div className='centralized2'>Inner Box</div>
                                    <div className='centralized2'>Loose Units</div>
                                    <div className='centralized2'>Total Units</div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF' }} >
                                    <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                        <input type='number' className='small-input-cs' name="outerBoxQtyDamaged" value={outerBoxQtyDamaged} onChange={(e) => { this.setNameToValue(e) }} />
                                    </div>
                                    <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                        {(Number(innerBoxes) > 0) ?
                                            <input type='number' className='small-input-cs' name="innerBoxQtyDamaged" value={innerBoxQtyDamaged} onChange={(e) => { this.setNameToValue(e) }} />
                                            :
                                            <div>-</div>
                                        }
                                    </div>
                                    <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                        <input type='number' className='small-input-cs' name="looseUnitsDamaged" value={looseUnitsDamaged} onChange={(e) => { this.setNameToValue(e) }} />
                                    </div>
                                    <div className='centralized2' >
                                        {badQty}
                                    </div>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-around', margin: '5px 0px', fontSize: '16px', fontWeight: '600' }}>
                                    <div className='centralized2'></div>
                                    <div className='centralized2' style={{ width: '50%', textAlign: 'end' }}>
                                        <div>Total quantity: </div>
                                        <div>(as per invoice)</div>
                                    </div>
                                    <div className='centralized2'>{goodQty + badQty}</div>
                                </div>
                                <hr style={{ borderColor: 'black', marginTop: '2px' }} />

                                {/* <div className="top-twenty" style={{ fontWeight: 700 }}>Details about the Damaged quantity</div>
							{damageReasons.map((reason, index) => {
								return (
									<div style={{ display: 'flex', alignItems: 'flex-start', margin: '10px' }} key={'dmgReason' + index}>
										<input type="radio" name="damageReasonType" id={reason.id} value={reason.id} onChange={(e) => { this.setState({ damageReasonType: e.target.value }) }} style={{ marginRight: '5px' }} />
										<label htmlFor={reason.id} style={{ textAlign: 'left', fontWeight: 400 }}>{reason.reason_name}</label>
									</div>
								)
							})} */}
                                {/* <div className="top-twenty" style={{ textDecoration: 'underline', color: '#ff810a', cursor: 'pointer' }} onClick={this.resetDamagedParameters}>- No Damaged quantity</div> */}
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <button className="btn btn-warning" style={{ cursor: 'pointer' }} onClick={this.resetDamagedParameters}>
                                        - No Damaged quantity
                                    </button>
                                </div>

                            </div>
                            :
                            // <div className="top-twenty" style={{ textDecoration: 'underline', color: '#2891E1', cursor: 'pointer' }} onClick={() => { this.setState({ showAddDamagedQty: !showAddDamagedQty }) }}>
                            //     + Add Damaged Quantity (if any)
                            // </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <button className="btn btn-info top-twenty" style={{ cursor: 'pointer' }} onClick={() => { this.setState({ showAddDamagedQty: !showAddDamagedQty }) }}>
                                    + Add Damaged Quantity (if any)
                                </button>
                            </div>

                        }


                        <div className="top-twenty" style={{ fontWeight: 700 }}>What are the LOT details mentioned on the product?</div>

                        <div style={{ display: 'flex', alignItems: 'flex-start', margin: '10px' }}>
                            <input type="radio" name="dateType" id='date1freebieDetails' value='date1' onChange={(e) => { this.makeDatesNull(); this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
                            <label htmlFor='date1freebieDetails' style={{ textAlign: 'left', fontWeight: 400 }}>Manufacturing Date and Expiry Date</label>
                        </div>
                        {(dateType === 'date1') ?
                            <React.Fragment>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <div style={{ width: '300px', margin: '5px 30px' }}>
                                        <InputFloating type="date" label="Manufacturing Date" name="manufacturingDate" value={manufacturingDate} onChange={this.setNameToValue} />
                                        {(!this.isManufacturingDateValid()) ? <div className="error-text-fix">Please Enter Valid Manufacturing Date</div> : null}
                                    </div>
                                    <div style={{ width: '300px', margin: '5px 30px' }}>
                                        <InputFloating type="date" label="Expiry Date" name="expiryDate" value={expiryDate} onChange={this.setNameToValue} />
                                        {(!this.isExpiryDateValid()) ? <div className="error-text-fix">Please Enter Valid Expiry Date</div> : null}
                                    </div>
                                </div>
                                {this.getShelfLife(1)}
                            </React.Fragment>
                            :
                            null
                        }

                        <div style={{ display: 'flex', alignItems: 'flex-start', margin: '10px' }}>
                            <input type="radio" name="dateType" id='date2freebieDetails' value='date2' onChange={(e) => { this.makeDatesNull(); this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
                            <label htmlFor='date2freebieDetails' style={{ textAlign: 'left', fontWeight: 400 }}>Manufacturing Date and Shelf Life</label>
                        </div>
                        {(dateType === 'date2') ?
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <div style={{ width: '300px', margin: '5px 30px 18px 30px' }}>
                                    <InputFloating type="date" label="Manufacturing Date" name="manufacturingDate" value={manufacturingDate} onChange={(e) => { this.setState({ manufacturingDate: e.target.value }, () => { this.changeExpiryDate() }) }} />
                                    {(!this.isManufacturingDateValid()) ? <div className="error-text-fix">Please Enter Valid Manufacturing Date</div> : null}
                                </div>
                                <div style={{ width: '300px', display: 'flex', justifyContent: 'center', margin: '5px 30px 18px 30px' }}>
                                    <div style={{ width: '50%' }}>
                                        <InputFloating type="text" label="Time To Expiry" value={expDays} onChange={this.handleExpTimeChange} />
                                    </div>
                                    <div style={{ width: '50%' }}>
                                        <ExpDropSelector options={expTimeSpanList} selected={expTimeSpan} classes={{ drop: 'invoice-type-drop' }} selctionChange={this.handelExpTimeSpanChange} type={'Expiry Time Span'} />
                                    </div>
                                </div>
                                {(manufacturingDate && expiryDate && (expiryDate.length === 10)) ?
                                    <React.Fragment>
                                        <div style={{ width: '300px', margin: '5px 30px 18px 30px', opacity: '0.8' }}>
                                            [ Expiry Date: {this.dateFormatChange(expiryDate)} ]
                                            {(!this.isExpiryDateValid()) ? <div className="error-text-fix">Invalid Expiry Date</div> : null}
                                        </div>
                                        {this.getShelfLife(2)}
                                    </React.Fragment>
                                    :
                                    null
                                }
                            </div>
                            :
                            null
                        }

                        <div style={{ display: 'flex', alignItems: 'flex-start', margin: '10px' }}>
                            <input type="radio" name="dateType" id='date3freebieDetails' value='date3' onChange={(e) => { this.setMfgDateToday(); this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
                            <label htmlFor='date3freebieDetails' style={{ textAlign: 'left', fontWeight: 400 }}>Best Before / Expiry Date</label>
                        </div>
                        {(dateType === 'date3') ?
                            <React.Fragment>
                                <div style={{ width: '250px', margin: '5px 30px' }}>
                                    <InputFloating type="date" label="Expiry Date" name="expiryDate" value={expiryDate} onChange={this.setNameToValue} />
                                    {(!this.isExpiryDateValid()) ? <div className="error-text-fix">Please Enter Valid Expiry Date</div> : null}
                                </div>
                                {this.getShelfLife(3)}
                            </React.Fragment>
                            :
                            null
                        }
                    </div>
                </div>
                {(this.isItemAbleToAddInPallet()) ?
                    <div className="bottom-btn" style={{ left: '0', right: '0' }}>
                        <button className="btn btn-big-fin" onClick={() => this.addItemToPallet(false)}>Tag to Pallet</button>
                    </div> : null
                }
            </div>
        )
    }

    proceedClicked = () => {
        const { shortInwardReason } = this.state;
        if (shortInwardReason === 'extra') {
            this.addItemToPallet(true);
        }
        else if (shortInwardReason === 'edit') {
            this.setState({ shortInward: false });
        }
    }

    closeError = () => {
        this.setState({ error: null });
        if (this.state.errorType === 'special') {
            this.closeAddedToPalletBox();
        }

    }

    render() {
        const { loading, error, initialLoading, shortInward, shortInwardReason, showAddedToPalletBox } = this.state;

        // after we get data from other components in componentDidMount, then only render rest of UI
        if (initialLoading) {
            return (
                <MobLoader />
            )
        }

        return (
            <div style={{ backgroundColor: 'white', margin: '10px' }} >
                <div className="visible-xs visible-sm">{this.getHeader()}</div>
                {this.freebieDetailsUI()}
                {(loading) ?
                    <MobLoader /> : null
                }
                {(error) ?
                    <ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
                }
                <Dialog open={shortInward} maxWidth="lg" fullWidth={true} onClose={() => this.setState({ shortInward: false })} classes={{ 'paper': 'tw-margn-class' }}>
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            <img src={warn} alt="success-img" style={{ height: '30px', marginRight: '10px' }} />
                            <div>Select reason for Freebie short inward</div>
                        </div>
                        <div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '10px' }}></div>

                        <div style={{ display: 'flex', alignItems: 'flex-start', margin: '20px 10px 10px 10px' }}>
                            <input type="radio" name="shortInwardReason" id="shortInwardOption1" value={'extra'} onChange={(e) => { this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
                            <label htmlFor="shortInwardOption1" style={{ textAlign: 'left' }}>Vendor supplied less quantity</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', margin: '10px' }}>
                            <input type="radio" name="shortInwardReason" id="shortInwardOption2" value={'edit'} onChange={(e) => { this.setNameToValue(e) }} style={{ marginRight: '5px' }} />
                            <label htmlFor="shortInwardOption2" style={{ textAlign: 'left' }}>I want to edit the quantity</label>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '80px' }}>
                            <button className="btn" onClick={() => this.setState({ shortInward: false })}>Cancel</button>
                            <button disabled={!shortInwardReason} className="btn btn-jt-green" onClick={this.proceedClicked}>Proceed</button>
                        </div>
                    </div>
                </Dialog>
                <Dialog open={showAddedToPalletBox} fullWidth={true} onClose={this.closeAddedToPalletBox}>
                    <div style={{ fontSize: '18px', textAlign: 'center', padding: '10px' }}>
                        <div className="text-right" onClick={this.closeAddedToPalletBox}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
                        <div className="top-thirty"><img src={filled_tick} alt="success-img" className="top-thirty" style={{ height: '60' }} /></div>
                        <div className="top-thirty"><div className="top-thirty">Freebie Added To Pallet Successfully</div></div>
                        <div className="top-thirty"><div className="top-twenty"></div></div>
                    </div>
                </Dialog>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/FreebieDetails.js